(function($) {

	'use strict';

	var init = function() {

        deployShadow();
        
    };
    
    var deployShadow = function() {
        $(window).scroll(function() {

            if($('.hp-introduction')[0]) {
                if($(window).scrollTop() > ($('.hp-introduction').height() - $('header').height() - 1)) {
                    $('header').addClass('shadow');
                } else {
                    $('header').removeClass('shadow');
                }
            }

            if($('.sd-introduction')[0]) {
                if($(window).scrollTop() > ($('.sd-introduction').height() - $('header').height() - 1)) {
                    $('header').addClass('shadow');
                } else {
                    $('header').removeClass('shadow');
                }
            }

        });
    }

	$(document).ready(function() {
		init();
	});

})(jQuery);